<template>
  <div class="container col-sm-8 center">
    <!-- <h1 class="text-center">Theory</h1>
    <br /> -->
    <h2>The Text of the Hebrew Bible</h2>
    <div class="row">
      <div class="col-sm-8">
        Our appreciation of the Hebrew text of the Bible is rooted in the idea
        of Hebraica Veritas. Yet, during most of the current era this was
        mediated by translations: the Septuagint, the Vetus Latina, Jerome’s
        Vulgate. And even, when Luther translated the Old Testament from the
        Hebrew text, it was mediated by the Masoretic vocalization of the Mikraot
        Gedolot or Rabbinic Bible. In that regard we tend to forget that what the
        Biblical authors called Scriptures was the consonantal Hebrew text.
      </div>
      <div class="col-sm-4">
        <img style="width: 100%" :src="`${publicPath}1QDeut_fragment.png`" />
      </div>
    </div>
    <h2>The Tanakh Hebrew Text and the Nekudot</h2>
    <div class="row">
    <div class="col-sm-4">
      <img style="width: 100%" :src="`${publicPath}stanligrad_codex_fragment.png`" />
    </div>
      <div class="col-sm-8">
        During the Middle Ages, the Jewish Scholars known as the Masoretes
        developed systems of graphic signs (vowel points or "pointing" or
        Nekudot) to encode the traditional oral reading of the Hebrew Bible.
        These traditions were not invented by the Masoretes but were a
        "graphemic notation" for phonemic and phonetic entities that had been
        transmitted orally for generations before the introduction of graphic
        vowel points by the Masoretes around the 6th or 7th century CE.
      </div>
    </div>
    <h2>Conflicting Vocalization Traditions</h2>
    <div class="row">
      <div class="col-sm-12">
        Because the written biblical text was originally unvocalized or
        semi-vocalic, various reading traditions emerged, leading to
        significant conflicts in meaning and grammar across different
        historical witnesses.
        Ancient translators utilized two primary modes of operation that often
        resulted in different vocalizations from the eventually standardized
        Masoretic Text (MT):
        <ul>
          <li>
            Some concluded a word's meaning directly from the written
            consonants and the context without necessarily consulting an
            authoritative oral vocalization.
          </li>
          <li>
            Other translators consulted an authoritative oral tradition first
            and then selected the meaning based on that specific vocalized
            form. Allegedly this was Jerome’s approach.
          </li>
        </ul>
      </div>
    </div>
    <h2>Hapax legomena</h2>
    <div class="row">
      <div class="col-sm-8">
        A hapax legomenon (plural: hapax legomena) is literally a Greek term
        meaning "a word spoken once". In the context of biblical scholarship,
        it generally refers to a word that occurs only once within a specific
        corpus, such as the Masoretic Text (MT), the Septuagint (LXX), or the
        New Testament (NT).
      </div>
      <div class="col-sm-4">
        <img style="width: 100%" :src="`${publicPath}petersburg_codex_fragment.png`" />
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  name: 'TheoryView',
  data () {
    return {
      publicPath: process.env.BASE_URL,
    }
  },
  props: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  text-align: center;
  margin-top: 2em;
  margin-bottom: 1em;
}
</style>
